import styles from "../showroomForm.css";
import Textarea from "../../../../design-system/components/Textarea/Textarea.jsx";

/**
 * A React functional component that renders a text area for handling multi-line text input.
 *
 * @param {Object} params - The parameter object.
 * @param {string} params.fieldKey - The key associated with the field in the form's data object.
 * @param {string} params.label - Label text for the text area input.
 * @param {string} params.description - Description text for the text area input.
 * @param {Object} params.formData - The current state object containing form data.
 * @param {Function} params.setFormData - Setter function to update the form data state.
 * @param {boolean} [params.required] - Indicates whether the text area is required.
 * @param {Function} [params.validate] - Function to handle validation of the input.
 * @param {string} [params.error] - Error message to display.
 * @return {JSX.Element} A JSX element containing a multi-line text input with relevant properties and handlers.
 */
export function MultiLine({
  fieldKey,
  label,
  description,
  formData,
  setFormData,
  required,
  validate,
  error,
}) {
  return (
    <div className={styles.formGroup}>
      {label && (
        <h2>
          {label}
          {required && "*"}
        </h2>
      )}
      {description && <p className={styles.description}>{description}</p>}
      <Textarea
        name={fieldKey}
        label={label}
        value={
          formData[fieldKey]
            ? (formData[fieldKey].data ?? formData[fieldKey])
            : ""
        }
        onChange={(e) => {
          setFormData((prevFormData) => ({
            ...prevFormData,
            [fieldKey]: e.target.value,
          }));

          if (validate) validate(e);
        }}
        required={required}
        error={error}
        width100
        theme={"dark"}
      />
    </div>
  );
}
